import React from "react";
import {useQuery} from "@apollo/client";
import ListTable from "../../shared/ListTable";
import {getAllergiesQuery} from "../../client/allergies/AllergyQueries";
import Loader from "../../shared/Loader";

const ClientAllergiesList = ({ client }) => {
  const { data, loading } = useQuery(getAllergiesQuery, { variables: { clientId: client.id } })

  const header = <tr>
    <th>Alergen</th>
    <th>Nivel Alergie</th>
  </tr>

  const listItem = (item, index) => {
    return <tr key={index}>
      <td>{item.name}</td>
      <td>{item.level}</td>
    </tr>
  }

  if (loading) return <Loader />;

  return (
    <div className="row justify-content-md-center">
      <div className=" justify-content-md-center">
        <div className="page-container col">
          <ListTable data={data && data.allergies} header={header} listItem={listItem}
                     searchFields={['name', 'level']} />
        </div>
      </div>
    </div>
  )
};

export default ClientAllergiesList;
